export default __webpack_public_path__ + "static/media/marauders-map-v5.0-03-04.fc84c2db.jpg";